import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-broker-code-registration-modal',
  templateUrl: './broker-code-registration-modal.component.html',
  styleUrls: ['./broker-code-registration-modal.component.scss']
})
export class BrokerCodeRegistrationModalComponent implements OnInit {

  listErrors: any[] = [];
  typeModal: string = 'error';

  constructor(
    private dialogRef: MatDialogRef<BrokerCodeRegistrationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.typeModal = this.data.data.objData.type;
    this.listErrors = this.data.data.objData.data;
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
